import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class PostSubmissionUseCase {
  constructor(private judgeRepository: JudgeRepository) {}

  async postSubmission(problemId: string, programLanguage: ProgramLanguageType, sourceCode: string): Promise<string> {
    try {
      const data = await this.judgeRepository.postSubmission(problemId, programLanguage, sourceCode)
      return data
    } catch (error) {
      console.error(`Error in PostSubmissionUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
